import { shouldPolyfill } from '@formatjs/intl-numberformat/should-polyfill'

async function polyfill(locale) {
  if (shouldPolyfill()) {
    // Load the polyfill 1st BEFORE loading data
    await import('@formatjs/intl-numberformat/polyfill')
  }

  if (Intl.NumberFormat.polyfilled) {
    switch (locale) {
      default:
        await import('@formatjs/intl-numberformat/locale-data/en')
        break
      case 'ru':
        await import('@formatjs/intl-numberformat/locale-data/ru')
        break
    }
  }
}

polyfill()
polyfill('ru')
